module.exports = __webpack_public_path__ + "static/media/star.0e6d7ada.svg";